import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { initApiClient } from './api/client';
import { MOCK_ENABLED } from './env';
import './index.css';
import { loadConfig } from './lib/config';

async function bootstrap() {
  await loadConfig();
  initApiClient();

  if (MOCK_ENABLED) {
    const { worker } = await import('./api/mock/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Root element not found');

  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

bootstrap();
